cockpitApp.controller('checkoutController', [
  '$rootScope', '$scope','$filter', '$localStorage', '$mdDialog', '$timeout', '$interval', '$sce', '$httpParamSerializer', '$anchorScroll', 'gettextCatalog', 'navigationHelper', 'checkout', 'profile', 'basketHelper', 'baggageHelper', 'bookingHelper', 'componentHelper', 'functionalities', 'dataHelper', 'profileHelper', 'logsProvider', 'checkoutHelper', 'segmentHelper',
  function($rootScope, $scope, $filter, $localStorage, $mdDialog, $timeout, $interval, $sce, $httpParamSerializer, $anchorScroll, gettextCatalog, navigationHelper, checkout, profile, basketHelper, baggageHelper, bookingHelper, componentHelper, functionalities, dataHelper, profileHelper, logsProvider, checkoutHelper, segmentHelper)
  {
    $rootScope.appTitle = $rootScope.appName + ' - ' + gettextCatalog.getString('Checkout');
    $scope.adyenProcessPendingRequests = [];
    $scope.booking = $rootScope.booking;
    $scope.checkoutData = {};
    $scope.countriesScope = {};
    $scope.passengerList = bookingHelper.getPassengersToDisplay();
    $scope.saveProfileData = {
      'value': false
    };
    $scope.savePaymentCardToProfile = {
      'value': false
    };
    $scope.companyCreditCard = {
      'value': false
    };
    $scope.orderStatus = {};
    $scope.problematicSeatmapList = [];

    const adyenDropInStyle = {
        base: {
            fontSmoothing: 'antialiased',
            fontFamily: 'Roboto, sans-serif',
            fontSize: '14px'
        },
    };

    const adyenDropInPlaceholders = {
        holderName: 'J. Smith',
        cardNumber: '1234 5678 9012 3456',
        expiryDate: 'MM/YY',
        securityCodeThreeDigits: '123',
        securityCodeFourDigits: '1234'
    };

    $scope.setCountries = function($type) {
      return $timeout(function() {
        $scope.countriesScope = $rootScope.countries;

        if ($type === 'phoneCountryCodeChanged') {
          $scope.phoneCountryCodeChanged = true;
        } else {
          $scope.countryCodeChanged = true
        }
      }, 400);
    };

    $scope.getTotalPricePerType = function() {
      const basketPrice = basketHelper.getTotalPricePerType();
      $scope.totalPrice = basketPrice.totalPrice;
      $scope.totalFee = basketPrice.totalFee;
    };

    $scope.prepareCheckout = function() {
      $scope.hasPnrTimedOutSeatsInBasket = basketHelper.hasPnrTimedOutSeatsInBasket();
      $scope.hasCconPnrHasTimedOutAncillariesInBasket = basketHelper.hasCconPnrHasTimedOutAncillariesInBasket();
      $scope.status = 'prepareCheckoutSuccess';
      $scope.$emit('checkoutReady');
    };

    $scope.resetInvoice = function(pane) {
      $scope.invoice = angular.copy($scope.checkoutData.invoice);
      $scope.checkoutForm.invoiceForm.$setDirty();

      if (pane && $scope.checkoutForm.invoiceForm.$valid) {
        pane.collapse();
      }
    };

    $scope.setInvoice = function() {
      var profileData = $scope.profile && $scope.profile.data;

      $scope.checkoutData.invoice = {
        salutation: '',
        firstName: profileData && profileData.firstName ? profileData.firstName : '',
        lastName: profileData && profileData.lastName ? profileData.lastName : '',
        email: profileData && profileData.email ? profileData.email : '',
        mobileCountryCode: profileData && profileData.mobileCountryCode ? profileData.mobileCountryCode : '',
        mobileNumber: profileData && profileData.mobileNumber ? profileData.mobileNumber : '',
        street: profileData && profileData.street ? profileData.street : '',
        streetNumber: profileData && profileData.streetNumber ? parseInt(profileData.streetNumber) : '',
        postcode: profileData && profileData.postcode ? profileData.postcode : '',
        addressAdditional: profileData && profileData.addressAdditional ? profileData.addressAdditional : '',
        company: profileData && profileData.company ? profileData.company : '',
        vatNumber: profileData && profileData.vatNumber ? profileData.vatNumber : '',
        city: profileData && profileData.city ? profileData.city : '',
        countryCode: profileData && profileData.countryCode ? profileData.countryCode : ''
      };

      $scope.invoice = angular.copy($scope.checkoutData.invoice);
      var profileDataCountryCode = profileData && profileData.countryCode;
      var profileDataMobileCountryCode = profileData &&  profileData.mobileCountryCode;
      $scope.profileCountryCode = $filter('filter')($rootScope.countries, {'code': profileDataCountryCode}, true)[0];
      $scope.profileMobileCountryCode = $filter('filter')($rootScope.countries, {'callingCode': profileDataMobileCountryCode}, true)[0];
    };

    $scope.isInvoiceValid = function() {
      var isInvoiceValid = $scope.invoice && $scope.invoice.street && $scope.invoice.streetNumber
        && $scope.invoice.postcode && $scope.invoice.city && $scope.invoice.countryCode
        && $scope.invoice.firstName && $scope.invoice.lastName && $scope.invoice.email;

      if ($rootScope.profile && $rootScope.profile.data && $scope.invoice && $rootScope.profile.data.email !== $scope.invoice.email) {
        isInvoiceValid = $scope.invoice.email === $scope.invoice.confirmEmail;
      }

      isInvoiceValid = ($scope.basket && $scope.basket.transfers) ? isInvoiceValid && $scope.invoice.salutation && $scope.invoice.mobileCountryCode && $scope.invoice.mobileNumber : isInvoiceValid;

      return isInvoiceValid;
    };

    $scope.$on('checkoutReady', function() {
      $scope.isCheckoutReady = true;

      if ($scope.isAccordionInvoiceReady) {
        $scope.prepareCheckoutInvoice();
      }

      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.has('sessionId') && searchParams.has('redirectResult')) {
        $scope.catchRedirectResult(searchParams);
      } else {
        $scope.initAdyenSessionAngular();
      }
    });

    $scope.$on('accordion-invoice:onReady', function() {
      $scope.isAccordionInvoiceReady = true;

      if ($scope.isCheckoutReady) {
        $scope.prepareCheckoutInvoice();
      }
    });

    $scope.prepareCheckoutInvoice = function() {
      // to not reset it when checkout fails and user did not want to save his profile data
      // timeout added due to the UI not fully being loaded at this point.
      $timeout(function() {
        if (!$scope.isInvoiceValid()) {
          $scope.setInvoice();
        }

        if (!$scope.isInvoiceValid()) {
            $scope.accordionInvoice.expand('invoice');
        } else {
          $scope.saveInvoice();
        }
      }, 1000);
    };

    $scope.saveInvoice = function() {
      if ($scope.checkoutForm && $scope.checkoutForm.invoiceForm) {
        $scope.checkoutForm.invoiceForm.$setSubmitted();

        if ($scope.basket && $scope.basket.transfers) {
          $scope.validateDropdown('salutation');
          $scope.validateDropdown('mobileCountryCode');
        }
        $scope.validateDropdown('countryCode');

        if ($scope.isInvoiceValid()) {
          $scope.accordionInvoice.collapse('invoice');
          $scope.checkoutData.invoice = angular.copy($scope.invoice);
        } else {
          $scope.accordionInvoice.expand('invoice');
        }
      }
    };

    $scope.validateDropdown = function(model) {
      $scope.checkoutForm.invoiceForm[model].$setDirty();
    };

    $scope.wiggleMessage = function() {
      $scope.animateMessage = false;

      $timeout(function() {
        $anchorScroll('messages');
        $scope.animateMessage = true;
      });
    };

    $scope.openServiceAgreementDialog = function(event) {
      componentHelper.openDialog('/element/dialog/service-agreement', event);
    };

    $scope.showAciTerms = function () {
      const departureDateTime = moment($scope.booking.departureDateTime);
      const threshold = moment().add(14,'days');

      return departureDateTime.isSameOrBefore(threshold) && $scope.basket && $scope.basket.automaticCheckins;
    };

    $scope.redirectToProblematicSegmentSeatmap = function(seatType) {
      var problematicSegment = null;

      switch (seatType) {
        case 'timedOut':
          if ($rootScope.basket && $rootScope.basket.seats) {
            problematicSegment = $filter('toArray')($rootScope.basket.seats, true).find(function(segmentSeat) {
              return basketHelper.hasSegmentTimedOutSeatsInBasket(segmentSeat.$key);
            });
          }
          break;
        case 'underReserve':
          if ($rootScope.basket && $rootScope.basket.seats) {
            problematicSegment = $filter('toArray')($rootScope.basket.seats, true).find(function(segmentSeat) {
              return basketHelper.hasSegmentUnderReserveSeatsInBasket(segmentSeat.$key);
            });
          }
          break;
        default:
          if ($rootScope.booking && $rootScope.booking.segments) {
              problematicSegment = segmentHelper.getFutureFlightSegments()[0];
          }
          break;
      }

      navigationHelper.redirectToSeatmap(problematicSegment);
    };

    $scope.setProblematicSeatmap = function() {
      var problematicSeats = null;
      var basketRemovalFormat = null;

      if ($rootScope.booking && $rootScope.booking.segments) {
        if ($scope.orderStatus && $scope.orderStatus.items && $scope.orderStatus.items.seats) {
            problematicSeats = {
                'filekey': $rootScope.booking.filekey,
                'segments': {}
            };

            basketRemovalFormat = {
                'filekey': $rootScope.booking.filekey,
                'passengers': {}
            };

            Object.keys($scope.orderStatus.items.seats).forEach(function (segmentExtendedNumber){
                for (var si = 0; si < $rootScope.booking.segments.length; si++) {
                    var segment = $rootScope.booking.segments[si];

                    if (String(segment.segmentExtendedNumber) === segmentExtendedNumber) {
                        var passengers = [];
                        problematicSeats.segments[segmentExtendedNumber] = [];
                        basketRemovalFormat.passengers[segmentExtendedNumber] = null;

                        for (var pi = 0; pi < $rootScope.booking.passengers.length; pi++) {
                            var passenger = $rootScope.booking.passengers[pi];
                            var pnrPosition = Object.keys($scope.orderStatus.items.seats[segmentExtendedNumber])[0];

                            if(String(passenger.pnrPosition) === pnrPosition){
                                var seat = Object.keys($scope.orderStatus.items.seats[segmentExtendedNumber][pnrPosition])[0];

                                passengers.push(passenger.firstname + ' ' + passenger.lastname + ' (' + seat + ')');
                                problematicSeats.segments[segmentExtendedNumber].push(seat);
                                basketRemovalFormat.passengers[segmentExtendedNumber] = pnrPosition;

                                break;
                            }
                        }

                        $scope.problematicSeatmapList.push({
                            'segment': segment,
                            'details': segment.departureAirportName + ' - ' + segment.arrivalAirportName + ' / ' + passengers.join(', ')
                        });

                        break;
                    }
                }
            });
        }
      }

      if (problematicSeats) {
          checkoutHelper.setProblematicSeatsInSession(problematicSeats);
      }

      if (basketRemovalFormat) {
          for (var segmentNum in basketRemovalFormat.passengers) {
              if (basketRemovalFormat.passengers.hasOwnProperty(segmentNum)) {
                  var pnrPos = basketRemovalFormat.passengers[segmentNum];
                  $scope.removeSeatFromBasket(segmentNum, pnrPos, null);
              }
          }
      }
    };

    $scope.redirectToProblematicSeatmap = function(problematicSegment) {
      navigationHelper.redirectToSeatmap(problematicSegment);
    };

    $scope.setBeforeUnload = function() {
      window.onbeforeunload = function() {
        return true;
      };
    };

    $scope.resetBeforeUnload = function() {
      window.onbeforeunload = undefined;
    };

    $scope.getPassengerByPnrPosition = function(booking, pnrPosition, isInfantRestricted) {
      return bookingHelper.getPassengerByPnrPosition(booking, pnrPosition, isInfantRestricted);
    };

    $scope.removeSeatFromBasket = function(segmentExtendedNumber, pnrPosition, event) {
      basketHelper.removeSeatFromBasket(segmentExtendedNumber, pnrPosition, event);
    };

    $scope.removeExtraFromBasket = function(serviceType, pnrPosition, segmentExtendedNumber, ssrCode, event) {
      basketHelper.removeExtraFromBasket(serviceType, pnrPosition, segmentExtendedNumber, ssrCode, event);
    };

    $scope.removeBaggageFromBasket = function(pnrPosition, baggageCode, segmentPriceListCode, event) {
      basketHelper.removeBaggageFromBasket(pnrPosition, baggageCode, segmentPriceListCode, event);
    };

    $scope.removeAutomaticCheckinFromBasket = function(pnrPosition, event) {
      basketHelper.removeAutomaticCheckinFromBasket(pnrPosition, event);
    };

    $scope.removeInsuranceBaggageFromBasket = function(pnrPosition, event) {
      basketHelper.removeInsuranceBaggageFromBasket(pnrPosition, event);
    };

    $scope.removeTransfersFromBasket = function(pnrPosition, event) {
      basketHelper.removeTransfersFromBasket(pnrPosition, event);
    };

    $scope.removeTransferConnectionFromBasket = function(connectionId, pnrPosition, event) {
      basketHelper.removeTransferConnectionFromBasket(connectionId, pnrPosition, event);
    };

    var functionalitiesFetchedListener = $scope.$on('functionalitiesFetched', function (event, functionalityList) {
      if ((!functionalityList || (functionalityList && functionalityList.indexOf('shoppingEnabled') > -1)) && !$rootScope.functionalities[$rootScope.activeFilekey].shoppingEnabled) {
        navigationHelper.redirectWithLocale('/details/:' + $scope.activeFilekey + '/:' + $scope.activeLastname);
      }
    });

    var refreshBasketListener = $rootScope.$on('refreshBasket', function() {
      $rootScope.basket = $localStorage.cockpit.baskets[$scope.activeFilekey];
      $scope.getTotalPricePerType();
    });

    $scope.$on('$destroy', refreshBasketListener, functionalitiesFetchedListener);

    $scope.getFunctionalities = function() {
      // If one of the shoppping functionalities is not within the root functionalities, refresh the functionalities
      var shoppingFunctionalities = basketHelper.getFunctionalitiesToRequestFromBasket();
      var incompleteFunctionalities = shoppingFunctionalities.some(function(functionality) {
        return !$rootScope.isFunctionalityEnabled(functionality);
      });

      if (incompleteFunctionalities) {
        functionalities.getFunctionalities(shoppingFunctionalities).then(
          function successCallback(response) {
            if (response.meta && response.meta.success && response.data) {
              $scope.prepareCheckout();
            }
          },
          function errorCallback() {
            $scope.status = 'prepareCheckoutError';
          }
        );
      } else {
        $scope.prepareCheckout();
      }
    };

    $scope.goToDetails = function(action) {
      navigationHelper.redirectWithLocale('/details/:' + $scope.activeFilekey + '/:' + $scope.activeLastname);
      dataHelper.setValue(action, 'action');
    };

    $scope.sendGATracking = function() {
      if (dataHelper.getValue('gaToCheckout')) {
        $rootScope.gaTracking('Checkout', 'click', dataHelper.getValue('gaToCheckout') + 'Success');
        dataHelper.setValue(false, 'gaToCheckout');
      }
    };

    $scope.showDeleteBaggageIcon = function(pnrPosition, segmentPriceListCode) {
      if ($rootScope.basket && $rootScope.basket.baggage && $rootScope.basket.baggage[pnrPosition]) {
        return baggageHelper.showDeleteBaggageIcon($rootScope.basket.baggage[pnrPosition], segmentPriceListCode);
      }
    };

    $scope.getAirlinesServiceAgreement = function() {
      if (!$scope.basket) {
          return '';
      }

      var airlinesServiceAgreement = {};

      var addAirline = function(airlineName) {
        if (airlineName) {
          airlinesServiceAgreement[airlineName] = true;
        }
      };

      angular.forEach($scope.basket.seats, function(seat) {
        addAirline(seat.marketingAirlineName);
      });

      angular.forEach($scope.basket.cashUpgrade, function(item) {
        addAirline(item.marketingAirlineName);
      });

      angular.forEach($scope.basket.extras, function(item) {
        addAirline(item.marketingAirlineName);
      });

      angular.forEach($scope.basket.baggage, function(baggageGroup) {
        angular.forEach(baggageGroup, function(baggageItem) {
          angular.forEach(baggageItem.segmentPriceList, function(segmentPrice) {
            var segmentIds = segmentPrice.segmentIds;
            angular.forEach(segmentIds, function(segmentId) {
              var segment = $rootScope.booking.segments.find(function(seg) {
                return seg.crypticSegmentValue === segmentId;
              });
              addAirline(segment && segment.marketingAirlineName);
            });
          });
        });
      });

      if ($scope.basket.automaticCheckins) {
        addAirline($rootScope.isInviaBrand() ? ' TC Flights Germany GmbH' : ' Airobot');
      }

      if ($scope.basket.insuranceBaggage) {
        addAirline(' BlueRibbonBags');
      }

      return Object.keys(airlinesServiceAgreement).toString();
    };

    $scope.getOrderPayloadDropIn = function() {
      var profileData = {
        firstName: $scope.checkoutData.invoice.firstName !== '' ? $scope.checkoutData.invoice.firstName : $scope.profile.data.firstName,
        lastName: $scope.checkoutData.invoice.lastName !== '' ? $scope.checkoutData.invoice.lastName : $scope.profile.data.lastName,
        mobileCountryCode: $scope.checkoutData.invoice.mobileCountryCode !== '' ? $scope.checkoutData.invoice.mobileCountryCode.split('_')[0] : null,
        mobileNumber: $scope.checkoutData.invoice.mobileNumber !== '' ? $scope.checkoutData.invoice.mobileNumber : $scope.profile.data.mobileNumber,
        street: $scope.checkoutData.invoice.street,
        streetNumber: $scope.checkoutData.invoice.streetNumber,
        addressAdditional: $scope.checkoutData.invoice.addressAdditional,
        postcode: $scope.checkoutData.invoice.postcode,
        city: $scope.checkoutData.invoice.city,
        countryCode: $scope.checkoutData.invoice.countryCode || 'DE',
        company: $scope.checkoutData.invoice.company !== '' ? $scope.checkoutData.invoice.company: null,
        vatNumber: $scope.checkoutData.invoice.vatNumber !== '' ? $scope.checkoutData.invoice.vatNumber : null
      };

      var sessionStorageProfile = JSON.parse(sessionStorage.getItem('session_profile'));

      var requestParams = {
        pnrIdentifier: $scope.booking.pnrIdentifier,
        filekey: $scope.activeFilekey,
        lastname: $scope.activeLastname,
        profileEmail: $scope.profile.data.email,
        basket: $scope.basket,
        locale: $scope.activeLocale,
        savePaymentCardToProfile: $scope.savePaymentCardToProfile.value,
        saveProfileData: $scope.saveProfileData.value,
        subdomain: $rootScope.subdomain,
        currency: $scope.booking.currencyCode,
        adyenReference: sessionStorageProfile.paymentData.adyenReference,
        shopperReference: sessionStorageProfile.paymentData.shopperReference,
        purchaseOrder: {
          salutation: $scope.checkoutData.invoice.salutation !== '' ? $scope.checkoutData.invoice.salutation : $scope.profile.data.salutation,
          travelAgencyNumber: $scope.booking.travelAgencyNumber,
          pnrIdentifier: $scope.booking.pnrIdentifier,
          filekey: $scope.activeFilekey,
          lastNames: $scope.booking.lastNames,
          marketingAirlinesCodes: basketHelper.getBasketMarketingAirlinesCodes(),
          crs: $scope.booking.crs,
          email: $scope.checkoutData.invoice.email !== '' ? $scope.checkoutData.invoice.email : $scope.profile.data.email,
          totalPrice: $scope.totalPrice,
          currencyCode: $scope.booking.currencyCode,
          locale: $scope.activeLocale,
          countryCode: $scope.checkoutData.invoice.countryCode || 'DE'
        },
        purchasePayment: null
      };

      angular.merge(requestParams.purchaseOrder, profileData);

      if (requestParams.saveProfileData) {
        requestParams.profileData = profileData;
      }

      return requestParams;
    };

    $scope.orderDropin = function() {
      try {
        if ($scope.checkoutForm.$valid) {
          $scope.dropin.submit();
        }
      } catch(e) {
        $scope.orderStatus.generalStatus = 'error';
        $scope.resetBeforeUnload();
        $mdDialog.cancel();
      }
    };

    $scope.requestParams = {};

    $scope.initAdyenSessionAngular = function() {
      const adyenRequestParams = $scope.getAdyenRequestParams();

      checkout.getSession(adyenRequestParams).then(
        function successCallback(response) {
          if (response.meta && response.meta.success && response.data) {
            const sessionData = {id: response.data.id, sessionData: response.data.sessionData};
            const sessionId = response.data.id;

            const configuration = {
              session: sessionData,
              environment: response.data.environment,
              amount: response.data.amount,
              clientKey: response.data.clientKey,
              analytics: {
                enabled: false
              },
              showRadioButton: true,
              showStoredPaymentMethods: !response.data.disableStorePaymentMethod,
              beforeSubmit: handleBeforeSubmit,
              onPaymentCompleted: handleOnPaymentCompleted,
              onPaymentFailed: handleOnPaymentFailed,
              onError: handleOnError,
              paymentMethodsConfiguration: {
                card: {
                  placeholders: adyenDropInPlaceholders,
                  styles: adyenDropInStyle,
                  hasHolderName: true,
                  holderNameRequired: true,
                  enableStoreDetails: !response.data.disableStorePaymentMethod
                },
                storedCard: {
                  placeholders: adyenDropInPlaceholders,
                  styles: adyenDropInStyle
                },
                paypal: {
                  style: {
                    label: 'pay'
                  },
                  blockPayPalCreditButton: true,
                  blockPayPalPayLaterButton: true
                }
              }
            };

            var sessionInfo = JSON.parse(sessionStorage.getItem('session_profile'));
            sessionInfo['paymentData'] = {
              adyenReference: response.data.reference,
              shopperReference: response.data.shopperReference
            };
            sessionStorage.setItem('session_profile', JSON.stringify(sessionInfo));

            sessionStorage.setItem('checkoutConfig_' + sessionId, JSON.stringify(configuration));

            $scope.loadDropIn(configuration);
          } else {
            $scope.status = 'prepareCheckoutError';
          }
        },
        function errorCallback(er) {
          $scope.status = 'prepareCheckoutError';
        }
      );
    };

    $scope.getAdyenRequestParams = function() {
      const countryCodeFromLocale = $scope.activeLocale.split('_')[1];
      return {
        countryCode: $scope.profileCountryCode ? $scope.profileCountryCode.code : countryCodeFromLocale,
        locale: $scope.activeLocale,
        basket: $scope.basket,
        filekey: $scope.activeFilekey,
        lastname: $scope.activeLastname,
        purchaseOrder: {
          marketingAirlinesCodes: basketHelper.getBasketMarketingAirlinesCodes(),
          totalPrice: $scope.totalPrice,
          currencyCode: $scope.booking.currencyCode,
        },
        returnUrl: document.URL
      };
    };

    function handleBeforeSubmit(data, component, actions) {
      if (!$scope.profile) {
        actions.reject(data);
        return navigationHelper.profileLoggedOutPostAction();
      }

      $scope.saveInvoice();
      $scope.checkoutForm.terms.$setDirty();
      $scope.checkoutForm.terms2.$setDirty();
      $scope.checkoutForm.terms3.$setDirty();

      if ($scope.showAciTerms()) {
        $scope.checkoutForm.aci.$setDirty();
      }

      $scope.hasPnrTimedOutSeatsInBasket = basketHelper.hasPnrTimedOutSeatsInBasket();
      $scope.hasCconPnrHasTimedOutAncillariesInBasket = basketHelper.hasCconPnrHasTimedOutAncillariesInBasket();

      if ($scope.hasPnrTimedOutSeatsInBasket || $scope.hasCconPnrHasTimedOutAncillariesInBasket || !checkoutHelper.isBasketValid($scope.basket, $scope.orderStatus)) {
        $scope.wiggleMessage();
        actions.reject(data);
        return;
      }

      if ($scope.adyenProcessPendingRequests.length === 0) {
        $scope.adyenProcessPendingRequests.push("payments");
        actions.resolve(data)
      }
    }

    function handleOnPaymentCompleted(result, component) {
      $scope.setBeforeUnload();
      $scope.orderStatus = {};

      if (result.resultCode === 'Authorised') {
        componentHelper.openDialog('/element/dialog/checkout-process', event);
        $scope.status = 'processingOrders';
        const requestParams = $scope.getOrderPayloadDropIn();

        $scope.adyenProcessPendingRequests.push("order");

        checkout.adyenOrder(requestParams).then(
          function successCallback(response) {
            $scope.adyenProcessPendingRequests = [];
            const responseData = !response.status ? response.data : response.data && response.data.data;
            const responseMeta = !response.status ? response.meta : response.data && response.data.meta;

            if (responseMeta && responseData) {
              $scope.orderStatus = responseData;

              if (responseMeta.success && responseData.generalStatus === 'success') {
                navigationHelper.redirectWithLocale('/confirmation/:' + $scope.activeFilekey + '/:' + $scope.activeLastname);
              } else {
                if (responseData.updatedBasket) {
                  $localStorage.cockpit.baskets[$rootScope.activeFilekey] = responseData.updatedBasket;
                  $rootScope.$emit('refreshBasket');
                }

                $scope.setProblematicSeatmap();
                $scope.reloadDropin();
              }

              const profileData = responseData.profileData;
              $rootScope.profile.data = profileData ? profileData : $rootScope.profile.data;
              profileHelper.updateSessionProfile();
            } else {
              $scope.orderStatus.generalStatus = 'error';
              $scope.status = 'error';
              $scope.setProblematicSeatmap();
              $scope.reloadDropin();
            }

            $scope.resetBeforeUnload();
            $mdDialog.cancel();
          },
          function errorCallback() {
            $scope.orderStatus.generalStatus = 'error';
            $scope.status = 'error';
            $scope.resetBeforeUnload();
            $mdDialog.cancel();
            $scope.setProblematicSeatmap();
            $scope.reloadDropin();
          }
        );
      }
    }

    function handleOnPaymentFailed(result, component) {
      $scope.orderStatus.generalStatus = 'paymentError';
      $scope.resetBeforeUnload();
      $mdDialog.cancel();
      $scope.reloadDropin();
    }

    function handleOnError(error, component) {
      // https://github.com/Adyen/adyen-web/issues/1177 we'll use this method for handling PayPal cancel dialog stuff
      // Called when Drop-in detects an invalid card number, invalid expiry date, or incomplete field. Called again when errors are cleared.
      // https://docs.adyen.com/payment-methods/cards/web-drop-in/#events
      if (error.name === 'CANCEL') {
        $scope.$apply(function() {
          $scope.reloadDropin();
        });
      }
    }

    $scope.loadDropIn = function(configuration) {
      return new Promise(function(resolve, reject) {
        if ($scope.dropin !== null) {
          $scope.dropin.unmount();
        }

        const AdyenCheckout = window.AdyenWeb.AdyenCheckout;
        const Dropin = window.AdyenWeb.Dropin;

        AdyenCheckout(configuration).then(function(checkout) {
          $scope.dropin = new Dropin(checkout, configuration).mount('#dropin-container');
          resolve(checkout);
        }).catch(function(error) {
          location.reload();
        });
      });
    };

    $scope.catchRedirectResult = function(params) {
      const sessionId = params.get('sessionId');
      const redirectResult = params.get('redirectResult');

      const config = JSON.parse(sessionStorage.getItem('checkoutConfig_' + sessionId));

      const configuration = Object.assign(config, {
        session: {id: sessionId},
        onPaymentCompleted: handleOnPaymentCompleted,
        onError: handleOnError
      });

      AdyenCheckout(configuration).then(function(checkout) {
        checkout.submitDetails({details: {redirectResult: redirectResult}});
      });
    };

    $scope.dropin = null;

    $scope.reloadDropin = function() {
      $scope.status = "prepareCheckoutSuccess";
      $scope.adyenProcessPendingRequests = [];
      $scope.initAdyenSessionAngular();
    }

    // init functions
    $scope.getTotalPricePerType();
    $scope.getFunctionalities();
    $scope.sendGATracking();
  }
]);
